module.exports = __webpack_public_path__ + "media/application/images/svgs/divide-square-4056c0b8324055b8f62f1b57acf8f0ab.svg";